












import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class AppSimpleButton extends Vue {
  @Prop(String) readonly label!: string;
  @Prop(String) readonly type!: string;
  @Prop({ type: Boolean, default: false }) readonly dense!: boolean;

  get btnType () {
    switch (this.type) {
      case 'white-outlined':
        return 'c-btn-white-outlined'
      case 'primary':
      default:
        return 'c-btn-primary'
    }
  }

  @Emit('click')
  clickHandler () {
    // do nothing
  }
}
